module.exports = __webpack_public_path__ + "static/media/visa.b1684820.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/visa.svg
// module id = 1330
// module chunks = 0